import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux';
import {motion} from "framer-motion"
import OnlyProButton from "./OnlyProButton";

import styles from './SideMenu.scss';



const SideMenu = (props)=> {

    const [menuIsOpen, setMenuIsOpen] = useState(false)
    const [dataPanelState, setDataPanelState] = useState(false)
    const [menu, setMenu] = useState("portail")
    const [subMenu, setSubMenu] = useState("map")


    const toggleMenuVariants = {
        open: { width: "195px", "align_items": "flex-start"},
        closed: { width:"72px", "align_items": "center" }
    }

    useEffect(()=>{

        document.querySelector('#portailSubMenu').classList.add("show");
        props.showcurrentSection('layers')
    },[])

    useEffect(()=>{
        (props.leftMenuIsOpen)?setMenuIsOpen(true):setMenuIsOpen(false)
    }, [props.leftMenuIsOpen])


    useEffect(()=>{
            //console.log(submenu)
    }, [subMenu])

    useEffect((e)=>{
        if(menu=="dashboard"){
            //document.querySelector('#ueFormSubMenu').classList.remove("show");
            document.querySelector('#portailSubMenu').classList.remove("show");
            let adminMenu = document.querySelector('#adminSubMenu');
            (adminMenu)?adminMenu.classList.remove("show"):null;
        }
        if(menu=="ueForm"){
            document.querySelector('#dashBoardSubMenu').classList.remove("show");
            document.querySelector('#portailSubMenu').classList.remove("show");
            let adminMenu = document.querySelector('#adminSubMenu');
            //(adminMenu)?adminMenu.classList.remove("show"):null;
        }
        if(menu=="portail"){
            document.querySelector('#dashBoardSubMenu').classList.remove("show");
            //document.querySelector('#ueFormSubMenu').classList.remove("show");
            let adminMenu = document.querySelector('#adminSubMenu');
            (adminMenu)?adminMenu.classList.remove("show"):null;
        }
        if(menu=="admin"){
            document.querySelector('#dashBoardSubMenu').classList.remove("show");
            //document.querySelector('#ueFormSubMenu').classList.remove("show");
            document.querySelector('#portailSubMenu').classList.remove("show");
        }

    }, [menu])

    const handleLeftMenuOpen = ()=>{
        props.setLeftMenuOpen(!props.leftPanelOpen);
    }

    const handleClickOpen = ()=>{
        setMenuIsOpen(!menuIsOpen)
        //props.sidebarstate(!menuIsOpen)
    }

    const handleClickLink = (evt)=>{
        if(evt){
            window.top.location.href = evt;
        }
    }

    const handleMenu = (name, menuTarget)=>{
        setMenu(name);
        const refTargetMenu = ['#dashBoardSubMenu', '#ueFormSubMenu', '#portailSubMenu', '#adminSubMenu'];

    }
    const handleNav = (evt,linkData)=>{
        setSubMenu(linkData.name);
        switch(linkData.type){
            case "url":
                handleClickLink(linkData.link);
                break;
            case "panel":
                props.showCenterSection(false)
                if(linkData.name=="print"){
                    props.setOpenPrintControl(!props.openPrintControl);
                    props.setLeftPanelOpen(false);
                }else if(linkData.name!="map"){
                    props.showcurrentSection(linkData.name)
                    props.setLeftPanelOpen(true);
                }else {
                    props.showcurrentSection(linkData.name)
                    props.setLeftPanelOpen(false);
                }
                break;
            case "center":
                props.setLeftPanelOpen(false)
                if(props.userId || linkData.name === "product" ){
                    props.setCurrentCenterPage(linkData.name)
                    props.showCenterSection('center_zone')
                }
                break;
            default:
                return;
        }
    }


    return (

        <motion.div
            animate={ menuIsOpen?"open":"closed"} id="dragbar"
            ransition={{ type: "easeInOut", duration: 0.7 }}
            variants={toggleMenuVariants}
        >
            <div className={"euMenuItems"} >
            {(!props.leftMenuIsOpen)
                    ?<button className="euBtnToggleMenu" type="button" onClick={handleLeftMenuOpen}  >
                        <i className="bi bi-arrow-bar-right"></i>
                    </button>
                    :null
                }
                <div id="sideMenuItems" className="ueNavitems" style={styles.ueNavitems}>

                    {/*
                    <a href="#"
                       className="btn btn-sm btn-outline-light"
                       style={{"marginBottom":"70px"}}
                       data-toggle="tooltip" data-placement="right" title="Ouvrir/fermer la section latérale"
                       onClick={handleClickOpen}>
                        {(menuIsOpen)?
                            <i className="bi bi-chevron-double-left"></i>
                            :<i className="bi bi-chevron-double-right"></i>
                        }
                    </a>
                    */}

                    <button
                        className={(menu=="dashboard")?
                            "ueLeftMenuBtnActif"
                            :"ueLeftMenuBtn"
                        }
                        id={"dashboardMenu"}
                        style={{"textAlign": (props.leftMenuIsOpen)?"left":"center","paddingLeft": props.leftMenuIsOpen && "24px"}}
                        type="button" data-toggle="collapse" data-target="#dashBoardSubMenu"
                        data-parent="#sideMenuItems" aria-expanded="false" aria-controls="dashBoardSubMenu"
                        onClick={(e)=>{handleMenu("dashboard", "#dashBoardSubMenu")}}
                    >
                        <i className="bi bi-speedometer"></i>
                        <span  style={{"display": menuIsOpen?"inline-block":"none", "marginLeft": "0.7rem"}}>Tableau de bord</span>
                    </button>
                    {(props.leftMenuIsOpen) ?
                        <div id="dashBoardSubMenu"
                             className="collapse ueLeftSubMenu "
                             aria-labelledby="headingOne"
                             data-parent="#sideMenuItems"
                             data-parent="#accordionExample"
                        >
                                <ul className="nav flex-column">
                                    <a className={"submenu nav-link "+(subMenu=="dashboard"?"active":"")}
                                       onClick={(e)=>handleNav(e,{"type":"center","name":"dashboard"})}
                                       href="#">Résumé {(!props.userId)?<OnlyProButton />:""}</a>
                                    <a className={"submenu nav-link "+(subMenu=="profil"?"active":"")}
                                       onClick={(e)=>handleNav(e,{"type":"center","name":"profil"})}
                                       href="#">Profil {(!props.userId)?<OnlyProButton />:""}</a>
                                    <a className={"submenu nav-link "+(subMenu=="userprefs"?"active":"")}
                                       onClick={(e)=>handleNav(e,{"type":"center","name":"userprefs"})}
                                       href="#">Préférences {(!props.userId)?<OnlyProButton />:""}</a>

                                    <a className={"submenu nav-link "+(subMenu=="invoices"?"active":"")}
                                       onClick={(e)=>handleNav(e,{"type":"center","name":"invoices"})}
                                       href="#">Factures {(!props.userId)?<OnlyProButton />:""}</a>
                                    <a className={"submenu nav-link "+(subMenu=="orders"?"active":"")}
                                       onClick={(e)=>handleNav(e,{"type":"center","name":"orders"})}
                                       href="#">Commandes {(!props.userId)?<OnlyProButton />:""}</a>
                                </ul>

                        </div>
                        :null
                    }

                    <button
                        className={(menu=="ueForm")?
                            "ueLeftMenuBtnActif"
                            :"ueLeftMenuBtn"
                        }
                        style={{"textAlign": (props.leftMenuIsOpen)?"left":"center","paddingLeft": props.leftMenuIsOpen && "24px"}}
                        type="button" data-toggle="collapse"
                        data-target="#ueFormSubMenu"
                        data-parent="#sideMenuItems"
                        aria-expanded="false"
                        aria-controls="ueFormSubMenu"
                        onClick={(e)=>{setMenu("ueForm");handleNav(e,{"type":"center","name":"product"})}}
                    >
                        <i className="bi bi-file-earmark-text"></i>
                        <span  style={{"display": menuIsOpen?"inline-block":"none", "marginLeft": "0.7rem"}}>Formulaires</span>
                    </button>

                    {
                        (props.leftMenuIsOpen) ? null:null
                    }

                    <button
                        className={(menu=="portail")?
                            "ueLeftMenuBtnActif"
                            :"ueLeftMenuBtn"
                        }
                        style={{"textAlign": (props.leftMenuIsOpen)?"left":"center","paddingLeft": props.leftMenuIsOpen && "24px"}}
                        type="button" data-toggle="collapse" data-target="#portailSubMenu"
                        data-parent="#sideMenuItems" aria-expanded="false" aria-controls="portailSubMenu"
                        onClick={(e)=>{setMenu("portail")}}
                    >
                        <i className="bi bi-map"></i>
                        <span  style={{"display": menuIsOpen?"inline-block":"none", "marginLeft":"0.7rem"}}>Portail</span>
                    </button>
                    {(props.leftMenuIsOpen) ?
                        <div id="portailSubMenu"
                             className="collapse ueLeftSubMenu"
                             aria-labelledby="headingOne"
                             data-parent="#sideMenuItems"
                             data-parent="#accordionExample"
                        >
                            <ul className="nav flex-column">
                                <a className={"submenu nav-link "+(subMenu=="map"?"active":"")}
                                   onClick={(e)=>handleNav(e,{"type":"panel","name":"map"})}
                                   href="#">Carte</a>
                                <a className={"submenu nav-link "+(subMenu=="data"?"active":"")}
                                   onClick={(e)=>handleNav(e,{"type":"panel","name":"data"})}
                                   href="#">Fiche Info</a>
                                <a className={"submenu nav-link "+(subMenu=="layers"?"active":"")}
                                   onClick={(e)=>handleNav(e,{"type":"panel","name":"layers"})}
                                   href="#">Données</a>
                                <a className={"submenu nav-link "+(subMenu=="librairie"?"active":"")}
                                   onClick={(e)=>handleNav(e,{"type":"panel","name":"librairie"})}
                                   href="#">Bibliothèque {(!props.userId)?<OnlyProButton />:""}</a>
                                <a className={"submenu nav-link "+(subMenu=="print"?"active":"")}
                                onClick={(e)=>handleNav(e,{"type":"panel","name":"print"})}
                                href="#">Imprimer</a>
                            </ul>
                        </div>
                        :null
                    }
                    {
                    (props.role === "admin")
                        ?<div>
                            <button
                                id={"adminMenu"}

                                className={(menu=="admin")?
                                    "ueLeftMenuBtnActif"
                                    :"ueLeftMenuBtn"
                                }
                                style={{"textAlign": (props.leftMenuIsOpen)?"left":"center","paddingLeft": (props.leftMenuIsOpen)?"24px":"none"}}
                                type="button" data-toggle="collapse" data-target="#adminSubMenu" data-parent="#sideMenuItems" aria-expanded="false" aria-controls="adminSubMenu"
                                onClick={(e)=>{setMenu("admin")}}

                            >

                                <i className="bi bi-gear"></i>
                                <span  style={{"display": menuIsOpen?"inline-block":"none", "marginLeft": "0.7rem"}}>Gestion</span>
                            </button>

                            { (props.leftMenuIsOpen)
                                ? <div id="adminSubMenu"
                                       className="collapse ueLeftSubMenu"
                                       aria-labelledby="headingOne"
                                       data-parent="#sideMenuItems"
                                       data-parent="#accordionExample"
                                >
                                    <ul className="nav flex-column">
                                        <a className={"submenu nav-link " + (subMenu == "adminHome" ? "active" : "")}
                                           onClick={(e) => handleNav(e, {
                                               "type": "url",
                                               "name": "adminHome",
                                               "link": "/admin",
                                               "icone": "bi bi-speedometer"
                                           })}
                                           href="#"><i className="bi bi-speedometer"></i> Dashboard</a>
                                        <a className={"submenu nav-link " + (subMenu == "adminUser" ? "active" : "")}
                                           onClick={(e) => handleNav(e, {
                                               "type": "url",
                                               "name": "adminUser",
                                               "link": "/admin/user",
                                               "icone": "bi bi-person"
                                           })}
                                           href="#"><i className="bi bi bi-person"></i> Utilisateur</a>
                                        <a className={"submenu nav-link " + (subMenu == "adminRole" ? "active" : "")}
                                           onClick={(e) => handleNav(e, {
                                               "type": "url",
                                               "name": "adminRole",
                                               "link": "/admin/role",
                                               "icone": "bi bi-bookmark-star"
                                           })}
                                           href="#"><i className="bi bi-bookmark-star"></i> Roles</a>
                                        <a className={"submenu nav-link " + (subMenu == "adminPerm" ? "active" : "")}
                                           onClick={(e) => handleNav(e, {
                                               "type": "url",
                                               "name": "adminPerm",
                                               "link": "/admin/permission",
                                               "icone": "bi bi-shield-lock"
                                           })}
                                           href="#"><i className="bi bi-shield-lock"></i> Permissions</a>
                                        <a className={"submenu nav-link " + (subMenu == "adminEntity" ? "active" : "")}
                                           onClick={(e) => handleNav(e, {
                                               "type": "url",
                                               "name": "adminEntity",
                                               "link": "/admin/entity",
                                               "icone": "bi bi-diagram-3"
                                           })}
                                           href="#"><i className="bi bi-diagram-3"></i> Structures</a>
                                        <a className={"submenu nav-link " + (subMenu == "adminLogs" ? "active" : "")}
                                           onClick={(e) => handleNav(e, {
                                               "type": "url",
                                               "name": "adminLogs",
                                               "link": "/admin/logevent",
                                               "icone": "bi bi-eye"
                                           })}
                                           href="#"><i className="bi bi-eye"></i> Journalisations</a>
                                    </ul>
                                </div>
                                : null
                            }
                    </div>
                    :null
                    }
                </div>
            </div>
            </motion.div>
    )
}

const mapStateToProps = state => {
    return {
        userId: state.MeReducer.id,
        currentSection : state.LeftPanelReducer.showCurrentSection,
        role : state.MeReducer.role,
        leftNavWidth : state.LeftPanelReducer.leftNavWidth,
        leftMenuIsOpen: state.LeftPanelReducer.leftMenuIsOpen,
        leftPanelWidth: state.LeftPanelReducer.leftNavWidth,
        leftPanelIsOpen: state.LeftPanelReducer.leftPanelIsOpen,
        openPrintControl: state.PrintReducer.openPrintControl,
    }
}

const mapDispatchTProps = dispatch => {
    return {
        showcurrentSection: (e) => dispatch( {type: 'SHOW_CURRENT_SECTION', data:e}),
        setLeftMenuOpen : (e) => dispatch({type: 'SET_LEFT_MENU_OPEN', data:e }),
        setLeftPanelWidth : (e) => dispatch({type: 'SET_LEFT_PANEL_WIDTH', data:e }),
        setLeftPanelOpen : (e) => dispatch({type: 'SET_LEFT_PANEL_OPEN', data:e }),
        setCurrentCenterPage: (e) => dispatch({type: 'SET_CURRENT_PAGE', data:e}),
        showCenterSection: (e) => dispatch( {type: 'SHOW_CENTER_SECTION', data:e}),
        setOpenPrintControl: (e) => dispatch( {type: 'OPEN_PRINT_CONTROL', data:e}),

    }
}

export default connect(mapStateToProps, mapDispatchTProps)(SideMenu);
